import {
    DrawerStack,
    SectionHeading,
    TikTokDrawerTimeSeriesWrapper,
} from './styledComponents';
import DrawerHeader from 'components/DrawerHeader';
import DownloadTimeSeriesButton from 'components/Button/DownloadTimeSeriesButton';
import Stack from 'components/Stack';
import TikTokTimeSeriesDrawerLogo from '../TikTokTimeSeriesDrawerLogo';
import TopPostsLogo from '../TopPostsLogo';
import { UpgradeToSpateProLink } from 'components/NoAccessMessage';

function TikTokDrawerContentIndividualHashtagStarter({ hashtag, initialData }) {
    const name = initialData?.name || hashtag;

    return (
        <Stack $space="1.5rem" css="padding: 1.5rem 0 7rem 0;">
            <DrawerHeader name={name} capitalize={false} />
            <DrawerStack $direction="row" $space="15px" css="display: flex;">
                <DownloadTimeSeriesButton
                    data={null}
                    css="font-size: 1rem; flex-shrink: 0; margin-left: auto;"
                />
            </DrawerStack>
            <TikTokDrawerTimeSeriesWrapper>
                <Stack
                    $direction="column"
                    $space="1.5rem"
                    css="display: flex; flex-direction: column; align-items: center; padding: 3.25rem 0;"
                >
                    <TikTokTimeSeriesDrawerLogo />
                    <span css="text-align: center;">
                        View trend performance across <br />
                        TikTok and Search.
                    </span>
                    <UpgradeToSpateProLink />
                </Stack>
            </TikTokDrawerTimeSeriesWrapper>
            <DrawerStack>
                <SectionHeading>
                    <span css="display: flex; align-items: center;">
                        Top Posts
                    </span>
                </SectionHeading>
                <Stack
                    $direction="column"
                    $space="1.5rem"
                    css={`
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        padding: 3.25rem 0;
                        background-color: ${({ theme }) => theme.gray_50};
                    `}
                >
                    <TopPostsLogo />
                    <img
                        src="https://storage.googleapis.com/spate-186619/images/app/top-posts-preview.png"
                        width="306"
                        height="173"
                    />
                    <span>
                        Explore top posts with Spate Pro.
                        <br />
                        What are consumers watching?
                    </span>
                    <UpgradeToSpateProLink />
                </Stack>
            </DrawerStack>
        </Stack>
    );
}

export default TikTokDrawerContentIndividualHashtagStarter;
